module.exports = __webpack_public_path__ + "img/2@2x.f0315846.png";